<div class="img-container">
  <div [ngClass]="size">
    <img *ngIf="account.avatarUrl"
         [src]="account.avatarUrl"/>
    <img *ngIf="!account.avatarUrl"
         [src]="'/assets/images/avatars/default_user.png'"/>
  </div>
</div>
